<h1 mat-dialog-title>Ausstalllisten / Lieferscheine</h1>

<div mat-dialog-content>
    <!--<strong>Gruppe: {{gruppe.bezeichnung}}</strong>-->

    <div *ngIf="!tierlisteData" class="one-row">
        <mat-form-field class="no-padding-margin-mat-form-field" style="width: 100%">
            <mat-label>Tierliste</mat-label>
            <mat-select multiple [formControl]="tierlistCtrl" [compareWith]="compareTierliste">
                <mat-option
                    style="line-height: 1em !important"
                    class="multiline-mat-option"
                    *ngFor="let tierliste of tierlisten"
                    [value]="tierliste"
                >
                    <div>
                        {{ tierliste?.kunden_abgang }} -
                        {{ tierliste?.gruppe_abgang }}
                    </div>
                    <div
                        >({{ tierliste.anzahl_tiere }} Tiere ({{ tierliste.anzahl_tiere_gesamt }}
                        insgesamt) -
                        {{ tierliste.datum_abgang | date: "dd.MM.yyy" }} -
                        {{ tierliste.kommentar ? tierliste.kommentar : "k.A." }})</div
                    >
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Liste als folgende(r) Dateityp(en) herunterladen:</strong>
        </div>
        <mat-checkbox [(ngModel)]="downloadAsPdf" style="margin-right: 24px">PDF</mat-checkbox>
        <mat-checkbox [(ngModel)]="downloadAsExcel" style="margin-right: 24px">Excel</mat-checkbox>
        <mat-checkbox [(ngModel)]="downloadAsCsv">CSV</mat-checkbox>
    </div>

    <!-- Zielbetrieb-Auswahl (nur bei PDF und mehreren Zielbetrieben) -->
    <div *ngIf="downloadAsPdf && showZielbetriebAuswahl && zielbetriebe.length > 1" class="one-row" style="margin-bottom: 12px">
        <mat-form-field class="no-padding-margin-mat-form-field" style="width: 100%">
            <mat-label>Zielbetrieb für PDF auswählen</mat-label>
            <mat-select [formControl]="zielbetriebCtrl">
                <mat-option *ngFor="let betrieb of zielbetriebe" [value]="betrieb.kunde_id">
                    {{ betrieb.bezeichnung_final }}
                    <span *ngIf="betrieb.zusatz_final"> - {{ betrieb.zusatz_final }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div style="width: 100%; margin-bottom: 12px">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Abteil je Tier anzeigen?</strong>
        </div>
        <mat-radio-group [formControl]="showAbteilCtrl">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>

    <div style="width: 100%">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Sortierung:</strong>
        </div>
        <mat-radio-group aria-label="Sortieren nach:" [formControl]="sortCtrl">
            <mat-radio-button style="margin-right: 12px" value="t.ohrmarke">Ohrmarke</mat-radio-button>
            <mat-radio-button style="margin-right: 12px" value="right(ohrmarke_code,5)"
                >Ohrmarke (letzte 5 Stellen)
            </mat-radio-button>
            <mat-radio-button style="margin-right: 12px" value="t.geburtsdatum">Geburtsdatum</mat-radio-button>
            <mat-radio-button *ngIf="showAbteilAnzeigen()" style="margin-right: 12px" value="gt.abteil_abgang"
                >Abteil</mat-radio-button
            >
        </mat-radio-group>
        <div style="margin-top: 12px">
            <div style="margin-bottom: 12px">
                <strong style="margin-right: 6px">Nach Geschlecht sortieren?</strong>
            </div>
            <mat-radio-group [formControl]="geschlechtSortCtrl">
                <mat-radio-button style="margin-right: 12px" value="none">nein</mat-radio-button>
                <mat-radio-button style="margin-right: 12px" value="w">weiblich zuerst</mat-radio-button>
                <mat-radio-button value="m">männlich zuerst</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Gruppe/Betrieb je Tier anzeigen?</strong>
        </div>

        <mat-radio-group [formControl]="showTiergruppeCtrl">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Einstalldatum je Tier anzeigen?</strong>
        </div>

        <mat-radio-group [formControl]="showEinstalldatumCtrl">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="showEinstalldatumCtrl.value == 1" style="margin-top: 12px">
            <div style="margin-bottom: 12px">
                <strong style="margin-right: 6px">Nach Einstalldatum sortieren?</strong>
            </div>
            <mat-radio-group [formControl]="einstalldatumSortCtrl">
                <mat-radio-button style="margin-right: 12px" value="none">nein</mat-radio-button>
                <mat-radio-button style="margin-right: 12px" value="asc">aufsteigend</mat-radio-button>
                <mat-radio-button value="desc">absteigend</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Gruppendetails auf PDF anzeigen?</strong>
        </div>

        <mat-radio-group [formControl]="showGruppendetailsCtrl" [disabled]="!downloadAsPdf">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Barcode auf PDF anzeigen?</strong>
        </div>

        <mat-radio-group [formControl]="showBarcodeCtrl" [disabled]="!downloadAsPdf">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Eingescannte Pässe anhängen?</strong>
        </div>

        <mat-radio-group [formControl]="addScansCtrl" [disabled]="!downloadAsPdf">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>

    <div style="width: 100%; margin: 12px 0">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Lieferschein nach Geschlecht splitten?</strong>
        </div>

        <mat-radio-group [formControl]="splitGeschlechtCtrl" [disabled]="!downloadAsPdf">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>

    <div style="width: 100%; margin: 12px 0" *ngIf="showImpfstoffe">
        <div style="margin-bottom: 12px">
            <strong style="margin-right: 6px">Verabreichte Impfstoffe anhängen?</strong>
        </div>

        <mat-radio-group [formControl]="addImpfstoffeCtrl" [disabled]="!downloadAsPdf">
            <mat-radio-button style="margin-right: 12px" [value]="1">Ja</mat-radio-button>
            <mat-radio-button [value]="0">Nein</mat-radio-button>
        </mat-radio-group>
    </div>
</div>

<div mat-dialog-actions style="display: flex; justify-content: flex-end; gap: 8px; width: 100%">
    <button mat-stroked-button style="margin-top: 8px" (click)="cancel()"> Abbrechen </button>
    <button mat-flat-button style="margin-top: 8px" color="accent" (click)="downloadFiles()"> OK </button>
</div>
